import { defineStore } from 'pinia';
import axios from 'axios';
import { ref } from 'vue';
import { useAuthStore } from '@stores';

const apiUrl = import.meta.env.VITE_API_URL;

export const useProfileStore = defineStore('profileStore', () => {
    const authStore = useAuthStore();
    const userData = ref(null);
    const userHistory = ref(null);
    const userLastStatus = ref(null);

    const getUserInfo = async (sessionId, userId) => {
        try {
            const {
                data: { data: responseData },
            } = await axios.get(apiUrl + '/v1/history/examiner', {
                params: {
                    session_id: sessionId,
                    user_id: userId,
                },
                headers: {
                    Authorization: 'Bearer ' + authStore.userToken,
                },
            });
            const { user, history, last_status } = responseData;

            userData.value = user;
            userHistory.value = history;
            userLastStatus.value = last_status;
        } catch ({ response }) {
            throw new Error(response.status);
        }
    };

    return {
        getUserInfo,
        userData,
        userHistory,
        userLastStatus,
    };
});
